<template>
  <div class="cell" :class="{'divide-line': divide}" @click="$emit('click')">
    <div class="left" :style="{color: leftColor}">{{ leftText }}</div>
    <div class="right" :style="{color: rightColor}" >{{ rightText }}</div>
    <div class="right-arr" >
      <i class="icon" v-show="rightArraw" :style="{color: rightColor}" >&#xe601;</i>
    </div>
  </div>
</template>

<script>
import rightArrPic from '../assets/img/right_arrow.png'
export default {
  props: {
    leftText: {
      type: String,
      required: true
    },
    leftColor: {
      type: String,
      default: '#363636'
    },
    rightText: {
      type: String
    },
    rightColor: {
      type: String,
      default: '#31c27c'
    },
    rightArraw: {
      type: Boolean,
      default: false
    },
    divide: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      rightArrPic: rightArrPic
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'

.divide-line
  border-bottom 1px solid $divide-line-color

.cell
  min-height  pt(95)
  display flex
  justify-content flex-start
  align-items center
  width 100%
  font-size $normal-font-size
  .left
    min-width  6em
    flex 0 1 auto
    text-align left
    single-line()
  .middle
    width 4em
    flex 0 1 auto
    text-align left
  .right
    flex 1 1 auto
    text-align right
    margin-right pt(20)
    // single-line()
  .right-arr
    width  pt(20)
    display flex
    justify-content center
</style>




// WEBPACK FOOTER //
// item-align-text-cell.vue?2e93a8bc